import {announce} from '@github-ui/aria-live'
import {on} from 'delegated-events'

on('click', '.js-refresh-sponsors-explore', () => {
  // eslint-disable-next-line i18n-text/no-en
  announce('Refreshing sponsored developers and organizations...')
})
